<template>
    <div class="row plain-element">
        <div v-if="!isLoggedIn()" class="dashboard-cards">
            <NoPermissionComponent/>
        </div>
        <div v-if="getUsername()">

            <div class="row plain-element">
                <div class=" col col-3 col-sm-3 col-md-2 col-lg-2 plain-element">
                    <div class="row row-cards">
                        <div class="row text-start row-back">
                            <a href="#" @click.prevent="$router.back()">
                                <span class="material-icons chevron-left">chevron_left</span> Back To Selection
                            </a>
                        </div>
                    </div>
                    <div class="row row-break"></div>
                    <div class="row row-break"></div>
                    <div v-if="showControls" class="row row-opportunities" style="padding-left: 12px;">
                        <div class="row  plain-element text-start">
                            <div class="input-field  col col-12 col-sm-12 col-md-11 col-lg-9 col-form">
                                <div class="row plain-element text-start">
                                    <label class="label-search">Interval</label>
                                </div>
                                <select v-model="interval" name="interval" id="interval" @change="clearSearch()">
                                    <option value="30d" selected>Last 30 Days</option>
                                    <option value="90d">Last 90 Days</option>
                                    <option value="ytd">YTD</option>
                                    <option value="1y">Last 365 Days</option>
                                </select>
                            </div>
                        </div>
                        <div class="row row-break"></div>
                        <div class="row  plain-element text-start">
                            <div class="input-field  col col-12 col-sm-12 col-md-12 col-lg-9 col-form">
                                <div class="row plain-element">
                                    <button class="btn btn-execute" @click="executeQuery()"
                                            style="width: 100%; margin-top: 30px !important;">
                                        Load Data
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row row-break"></div>
                        <div class="row row-break"></div>
                        <div class="row plain-element"  style="font-size: 18px;">
                          <div class="input-field  col col-12 col-sm-12 col-md-12 col-lg-9 col-form">
                           <table class="table table-borderless mb-0" style="font-size:18px;">
                              <tbody>
                                <tr style="background-color:#ffffff;">
                                    <td style="font-size:18px;">Critical Issues</td>
                                    <td style="font-size:18px;">-</td>
                                    <td class="fw-semibold" style="color:#c62828;font-size:18px;font-weight:600;">
                                        {{ getMeterHealthCheckCriticalIssues()?.length || 0 }}
                                    </td>
                                </tr>
                                <tr style="background-color:#ffffff;">
                                    <td style="font-size:18px;">Potential Issues</td>
                                    <td style="font-size:18px;">-</td>
                                    <td class="fw-semibold" style="color:#e6a700;font-size:18px;font-weight:600;">
                                        {{ getMeterHealthCheckPotentialIssues()?.length || 0 }}
                                    </td>
                                </tr>
                                <tr style="background-color:#ffffff;">
                                    <td style="font-size:18px;">Functioning</td>
                                    <td style="font-size:18px;">-</td>
                                    <td class="fw-semibold" style="color:#2e7d32;font-size:18px;font-weight:600;">
                                        {{ getMeterHealthCheckFunctioningMeters()?.length || 0 }}
                                    </td>
                                </tr>
                              </tbody>
                           </table>
                          </div>
                        </div>
                    </div>
                </div>
                <div class=" col col-3 col-sm-3 col-md-10 col-lg-10 plain-element">
                    <div v-if="getUsername() && getNestedSeuEnpi()" class="dashboard" v-cloak>
                        <div class="plain-element text-center">
                            <div class="row row-opportunities row-96">
                                <div class="row row-break"></div>
                                <div class="row row-break"></div>
                                 <p class="error" v-if="getFormError()">
                                    <span id="formError">{{ getFormError() }}</span>
                                 </p>
                                <div class="row  plain-element text-start">
                                    <div class=" col col-12 col-sm-12 col-md-10 col-lg-10 plain-element text-start">
                                        <div v-if="!getLoader() && !getFormError() && getMeterHealthCheckData()"
                                             class="row row-opportunities row-96">
                                            <div class="col col-12 col-sm-12 col-md-12 col-lg-12 plain-element text-start">
                                                <div class="row plain-element">
                                                    <div class=" col col-3 col-sm-3 col-md-3 col-lg-3 plain-element text-start">
                                                        <div class="btn-plans-tab-secondary"
                                                             @click="activateChartTab('heatmap')">
                                                            <div v-if="tab === 'heatmap'" class="tab-plans-active">
                                                                <span class="material-icons icon-chart">device_thermostat</span>Heatmap
                                                            </div>
                                                            <div v-else>
                                                                <span class="material-icons icon-chart">device_thermostat</span>Heatmap
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class=" col col-3 col-sm-3 col-md-3 col-lg-3 plain-element text-start">
                                                        <div class="btn-plans-tab-secondary"
                                                             @click="activateChartTab('critical issues')">
                                                            <div v-if="tab === 'critical issues'" class="tab-plans-active">
                                                                <span class="material-icons icon-chart">notification_important</span>Critical Issues
                                                            </div>
                                                            <div v-else>
                                                                <span class="material-icons icon-chart">notification_important</span>Critical Issues
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class=" col col-3 col-sm-3 col-md-3 col-lg-3 plain-element text-start">
                                                        <div class="btn-plans-tab-secondary"
                                                             @click="activateChartTab('potential issues')">
                                                            <div v-if="tab === 'potential issues'" class="tab-plans-active">
                                                                <span class="material-icons icon-chart">lightbulb</span>Potential Issues
                                                            </div>
                                                            <div v-else>
                                                                <span class="material-icons icon-chart">lightbulb</span>Potential Issues
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class=" col col-3 col-sm-3 col-md-3 col-lg-3 plain-element text-start">
                                                        <div class="btn-plans-tab-secondary"
                                                             @click="activateChartTab('functioning meters')">
                                                            <div v-if="tab === 'functioning meters'" class="tab-plans-active">
                                                                <span class="material-icons icon-chart">check_circle</span>Functioning Meters
                                                            </div>
                                                            <div v-else>
                                                                <span class="material-icons icon-chart">check_circle</span>Functioning Meters
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row row-break"></div>
                                        <div v-if="getLoader()" class="loader" id="loader"></div>
                                    </div>
                                </div>
                                <div v-if="!getLoader() && !getFormError() && getMeterHealthCheckData()" class="row  plain-element text-start">
                                    <div class="row row-break"></div>
                                    <div  class="row plain-element">
                                        <div  v-if="tab === 'heatmap'" class="row plain-element">
                                          <div class=" col col-12 col-sm-12 col-md-12 col-lg-12 plain-element text-start">
                                              <div v-if="getMeterHealthCheckHeatmap()" class="row  plain-element text-start">
                                                <div v-for="(status, meter) in getMeterHealthCheckHeatmap()" :key="meter" @click="activateHeatmapTab(status)"
                                                    class="col col-4 col-sm-4 col-md-3 col-lg-1 text-start heatmap-box"
                                                    :style="{ backgroundColor: status}">
                                                      {{ truncatechars(meter, 40) }}
                                                </div>
                                              </div>
                                          </div>
                                        </div>
                                        <div  v-if="tab === 'critical issues'" class="row plain-element">
                                          <div  class=" col col-12 col-sm-12 col-md-5 col-lg-5 plain-element text-start">
                                              <div id="parent" style="height: 800px;">
                                                  <div id="child">
                                                      <table class="table-metrics table-metadata" id="searchTable">
                                                          <thead>
                                                          <tr>
                                                              <th @click="sortTableNew(0)" class="text-start">Meter Name
                                                                  <span class="icon-stack">
                                                                      <span class="material-icons caret-down">expand_more</span>
                                                                      <span class="material-icons caret-up">expand_less</span>
                                                                  </span>

                                                              </th>
                                                              <th @click="sortTableNew(1)" class="text-end">Working
                                                                  <span class="icon-stack">
                                                                  <span class="material-icons caret-down">expand_more</span>
                                                                  <span class="material-icons caret-up">expand_less</span>
                                                              </span>
                                                              </th>
                                                              <th @click="sortTableNew(2)" class="text-end">Zero
                                                                  <span class="icon-stack">
                                                                      <span class="material-icons caret-down">expand_more</span>
                                                                      <span class="material-icons caret-up">expand_less</span>
                                                                  </span>
                                                              </th>
                                                              <th @click="sortTableNew(3)" class="text-end">No Data
                                                                  <span class="icon-stack">
                                                                      <span class="material-icons caret-down">expand_more</span>
                                                                      <span class="material-icons caret-up">expand_less</span>
                                                                  </span>
                                                              </th>
                                                          </tr>
                                                          </thead>
                                                          <tbody>
                                                          <tr v-for="(element, index) in getMeterHealthCheckCriticalIssues()"
                                                              :key="index">
                                                              <td class="text-start field-description" style="font-size: 14px; padding: 4px;">
                                                                  {{element.meter_name }}
                                                              </td>
                                                              <td class="text-end field-number" style="font-size: 14px; padding: 4px;">
                                                                  {{element.working}}%
                                                              </td>
                                                              <td class="text-end field-number" style="font-size: 14px; padding: 4px;">
                                                                  {{element.zero}}%
                                                              </td>
                                                              <td class="text-end field-number" style="font-size: 14px; padding: 4px;">
                                                                  {{element.no_data}}%
                                                              </td>
                                                          </tr>
                                                          </tbody>
                                                      </table>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class=" col col-12 col-sm-12 col-md-1 col-lg-1 plain-element text-start"></div>
                                          <div class=" col col-12 col-sm-12 col-md-6 col-lg-6 plain-element text-start">
                                            <meter-health-check-bar-graph :chart-data="getMeterHealthCheckGraphData()" style="height: 800px; width: 100%"></meter-health-check-bar-graph>
                                          </div>
                                        </div>
                                        <div v-if="tab === 'functioning meters'" class="row plain-element">
                                          <div class=" col col-12 col-sm-12 col-md-5 col-lg-5 plain-element text-start">
                                              <div id="parent" style="height: 800px;">
                                                  <div id="child">
                                                      <table class="table-metrics table-metadata" id="searchTable">
                                                          <thead>
                                                          <tr>
                                                              <th @click="sortTableNew(0)" class="text-start">Meter Name
                                                                  <span class="icon-stack">
                                                                      <span class="material-icons caret-down">expand_more</span>
                                                                      <span class="material-icons caret-up">expand_less</span>
                                                                  </span>

                                                              </th>
                                                              <th @click="sortTableNew(1)" class="text-end">Working
                                                                  <span class="icon-stack">
                                                                  <span class="material-icons caret-down">expand_more</span>
                                                                  <span class="material-icons caret-up">expand_less</span>
                                                              </span>
                                                              </th>
                                                              <th @click="sortTableNew(2)" class="text-end">Zero
                                                                  <span class="icon-stack">
                                                                      <span class="material-icons caret-down">expand_more</span>
                                                                      <span class="material-icons caret-up">expand_less</span>
                                                                  </span>
                                                              </th>
                                                              <th @click="sortTableNew(3)" class="text-end">No Data
                                                                  <span class="icon-stack">
                                                                      <span class="material-icons caret-down">expand_more</span>
                                                                      <span class="material-icons caret-up">expand_less</span>
                                                                  </span>
                                                              </th>
                                                          </tr>
                                                          </thead>
                                                          <tbody>
                                                          <tr v-for="(element, index) in getMeterHealthCheckFunctioningMeters()"
                                                              :key="index">
                                                              <td class="text-start field-description" style="font-size: 14px; padding: 4px;">
                                                                  {{element.meter_name }}
                                                              </td>
                                                              <td class="text-end field-number" style="font-size: 14px; padding: 4px;">
                                                                  {{element.working}}%
                                                              </td>
                                                              <td class="text-end field-number" style="font-size: 14px; padding: 4px;">
                                                                  {{element.zero}}%
                                                              </td>
                                                              <td class="text-end field-number" style="font-size: 14px; padding: 4px;">
                                                                  {{element.no_data}}%
                                                              </td>
                                                          </tr>
                                                          </tbody>
                                                      </table>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class=" col col-12 col-sm-12 col-md-1 col-lg-1 plain-element text-start"></div>
                                          <div class=" col col-12 col-sm-12 col-md-6 col-lg-6 plain-element text-start">
                                            <meter-health-check-bar-graph :chart-data="getMeterHealthCheckGraphData()" style="height: 800px; width: 100%"></meter-health-check-bar-graph>
                                          </div>
                                        </div>
                                        <div v-if="tab === 'potential issues'" class="row plain-element">
                                          <div class=" col col-12 col-sm-12 col-md-12 col-lg-10 plain-element text-start">
                                              <div id="parent" style="height: 800px;">
                                                  <div id="child">
                                                      <table class="table-metrics table-metadata" id="searchTable">
                                                          <thead>
                                                          <tr>
                                                              <th @click="sortTableNew(0)" class="text-start">Meter Name
                                                                  <span class="icon-stack">
                                                                      <span class="material-icons caret-down">expand_more</span>
                                                                      <span class="material-icons caret-up">expand_less</span>
                                                                  </span>

                                                              </th>
                                                              <th @click="sortTableNew(1)" class="text-end">Working
                                                                  <span class="icon-stack">
                                                                  <span class="material-icons caret-down">expand_more</span>
                                                                  <span class="material-icons caret-up">expand_less</span>
                                                              </span>
                                                              </th>
                                                              <th @click="sortTableNew(2)" class="text-end">Zero
                                                                  <span class="icon-stack">
                                                                      <span class="material-icons caret-down">expand_more</span>
                                                                      <span class="material-icons caret-up">expand_less</span>
                                                                  </span>
                                                              </th>
                                                              <th @click="sortTableNew(3)" class="text-end">No Data
                                                                  <span class="icon-stack">
                                                                      <span class="material-icons caret-down">expand_more</span>
                                                                      <span class="material-icons caret-up">expand_less</span>
                                                                  </span>
                                                              </th>
                                                              <th class="text-end"></th>
                                                              <th class="text-center">No Data Timestamps</th>
                                                          </tr>
                                                          </thead>
                                                          <tbody>
                                                          <tr v-for="(element, index) in getMeterHealthCheckPotentialIssues()"
                                                              :key="index">
                                                              <td class="text-start field-text" style="font-size: 14px; padding: 4px;">
                                                                  {{element.meter_name }}
                                                              </td>
                                                              <td class="text-end field-number" style="font-size: 14px; padding: 4px;">
                                                                  {{element.working}}%
                                                              </td>
                                                              <td class="text-end field-number" style="font-size: 14px; padding: 4px;">
                                                                  {{element.zero}}%
                                                              </td>
                                                              <td class="text-end field-number" style="font-size: 14px; padding: 4px;">
                                                                  {{element.no_data}}%
                                                              </td>
                                                              <td class="text-end field-site"></td>
                                                              <td class="text-start field-description-16" style="font-size: 14px; padding: 4px;">
                                                                  <template v-for="(timestamp, index) in element.no_data_timestamps" :key="index">{{ timestamp }}<br></template>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                      </table>
                                                  </div>
                                              </div>
                                          </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { sortTableNew, sortTableNew2, sortTableCurrencyInt2 } from "@/common/tables.js";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue";
import MeterHealthCheckBarGraph from "@/common/graphs/meter_health_check/MeterHealthCheckBarGraph.js";
import { truncatechars } from "@/common/general.js";

export default {
  name: "MeterHealthCheckView",
  components: {
    NoPermissionComponent,
    MeterHealthCheckBarGraph,
  },
  props: {
    site_code: {
      type: String,
      required: true,
    },
  },
  data() {
    const today = new Date();

    return {
      year: String(today.getFullYear()),
      month: String(today.getMonth() + 1).padStart(2, "0"),
      interval: "30d",
      threshold: 1,
      tab: "heatmap",
      seu: "All",
      showControls: false,
    };
  },
  methods: {
    sortTableNew: sortTableNew,
    sortTableNew2: sortTableNew2,
    sortTableCurrencyInt2: sortTableCurrencyInt2,
    ...mapGetters([
      "getUsername", "isLoggedIn", "getNestedSeuEnpi", "getLoader", "getFormError",
      "getMeterHealthCheckData","getMeterHealthCheckCriticalIssues", "getMeterHealthCheckFunctioningMeters", "getMeterHealthCheckPotentialIssues",
      "getMeterHealthCheckGraphData", "getMeterHealthCheckList", "getMeterHealthCheckHeatmap"
    ]),
    ...mapActions([
      "performSetFormError",  "fetchNestedSeuEnpi", "performExecuteMeterHealthCheckQuery", "performDownloadMeterHealthCheckExcelQuery"
    ]),
// STRINGS AND ARRAYS
    truncatechars: truncatechars,

//  NAVIGATION & BUTTONS
    activateChartTab(tabName) {
      this.tab = tabName;
    },
    clearSearch() {
      this.search = "";
    },
    activateHeatmapTab(status) {
      if (status === "#d96c6c") {
        this.tab = "critical issues";
      } else if (status === "#f4d266") {
        this.tab = "potential issues";
      } else if (status === "#b7ddb5") {
        this.tab = "functioning meters";
      }
      window.scrollTo(0, 0);
    },



// QUERIES
    async executeQuery() {
      this.tab = "heatmap";
      if (!this.threshold) {
        this.threshold = 0
      }
      await this.performExecuteMeterHealthCheckQuery({
        "site_code": this.site_code,
        "enpi_list": this.getNestedSeuEnpi()[this.seu],
        "interval": this.interval,
        "threshold": this.threshold
      });
      this.showControls = true;
    },
    downloadExcelQuery() {
      this.performDownloadMeterHealthCheckExcelQuery({
        "site_code": this.site_code,
        "enpi_list": this.getNestedSeuEnpi()[this.seu],
        "interval": this.interval,
      });
    },
  },
  computed: {

  },
  watch: {
    getNestedSeuEnpi: {
      immediate: true,
      handler(value) {
        if (value && Object.keys(value).length && !this.getMeterHealthCheckData()) {
          this.executeQuery();
        }
      }
    }
  },
  async created() {
    document.title = "Meter Health Check";
    this.performSetFormError(null);

    await this.fetchNestedSeuEnpi(this.site_code);

    this.executeQuery();

    window.scrollTo(0, 0);
  }

};
</script>

